import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * XP to prefetch more from brand endpoint on PDP.
 */
export const FE_PREFETCH_PDP_MORE_FROM_BRAND_250530 = experiment({
  name: "FE_PREFETCH_PDP_MORE_FROM_BRAND_250530",
  identifier: "RetailerTokenInSession",
  client: "RETAILER",
  notifyAfter: "2025-08-01",
  defaultValue: false,
  productArea: "PRODUCT_PAGE",
});
